import styled from 'styled-components';

export {
  ModalHeader,
  ModalContent,
  ModalBody,
  FormRow,
  FormActions,
  Button,
  ActivityIndicator,
} from 'styles/components';

export const SlotQuestion = styled.p`
  margin: 0;
`;

export const SlotActions = styled.div`
  display: grid;
  grid-template-columns: 140px repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 32px;

  > button {
    min-width: 0;
    width: 100%;
    height: auto;
    min-height: 48px;
    padding: 8px 16px;
    line-height: 1.2;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  @media (max-width: 560px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;
